import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../../../../components/textInput/textInput';

interface ErrorCounterProps {
  errorCount: number;
  onAdd: () => void;
  onMinus: () => void;
}
export function ErrorCounter({
  errorCount,
  onAdd,
  onMinus,
}: ErrorCounterProps) {
  const { t } = useTranslation();
  return (
    <ButtonGroup>
      <Button
        onClick={onMinus}
        disabled={errorCount === 0}
        variant="text"
        aria-label={t('accessibility.DECREMENT')}
      >
        <RemoveIcon fontSize="small" />
      </Button>
      <TextInput
        type="number"
        variant="standard"
        size="small"
        value={errorCount.toString()}
        sx={{ maxWidth: 100, input: { textAlign: 'center' } }}
        inputProps={{
          style: { fontSize: 40 },
          disableUnderline: true,
        }}
        name="errorCount"
        label=""
      />
      <Button
        onClick={onAdd}
        variant="text"
        aria-label={t('accessibility.INCREMENT')}
      >
        <AddIcon fontSize="small" />
      </Button>
    </ButtonGroup>
  );
}
